import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import AppLayout from '../layouts/AppLayout.vue'
import AuthLayout from '../layouts/AuthLayout.vue'
import { authService } from '../services/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'login' },
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/control/DashboardPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('../pages/control/resources/ResourceListPage.vue'),
        props: { moduleKey: 'projects' },
      },
      {
        name: 'project-create',
        path: 'projects/create',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'projects', mode: 'create' },
      },
      {
        name: 'project-view',
        path: 'projects/:id',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'projects', mode: 'view' },
      },
      {
        name: 'project-edit',
        path: 'projects/:id/edit',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'projects', mode: 'edit' },
      },
      {
        name: 'schedules',
        path: 'schedules',
        component: () => import('../pages/control/resources/ResourceListPage.vue'),
        props: { moduleKey: 'schedules' },
      },
      {
        name: 'schedule-create',
        path: 'schedules/create',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'schedules', mode: 'create' },
      },
      {
        name: 'schedule-view',
        path: 'schedules/:id',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'schedules', mode: 'view' },
      },
      {
        name: 'schedule-edit',
        path: 'schedules/:id/edit',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'schedules', mode: 'edit' },
      },
      {
        name: 'templates',
        path: 'templates',
        component: () => import('../pages/control/resources/ResourceListPage.vue'),
        props: { moduleKey: 'templates' },
      },
      {
        name: 'template-create',
        path: 'templates/create',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'templates', mode: 'create' },
      },
      {
        name: 'template-view',
        path: 'templates/:id',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'templates', mode: 'view' },
      },
      {
        name: 'template-edit',
        path: 'templates/:id/edit',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'templates', mode: 'edit' },
      },
      {
        name: 'smtp-profiles',
        path: 'smtp-profiles',
        component: () => import('../pages/control/resources/ResourceListPage.vue'),
        props: { moduleKey: 'smtp-profiles' },
      },
      {
        name: 'smtp-profile-create',
        path: 'smtp-profiles/create',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'smtp-profiles', mode: 'create' },
      },
      {
        name: 'smtp-profile-view',
        path: 'smtp-profiles/:id',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'smtp-profiles', mode: 'view' },
      },
      {
        name: 'smtp-profile-edit',
        path: 'smtp-profiles/:id/edit',
        component: () => import('../pages/control/resources/ResourceFormPage.vue'),
        props: { moduleKey: 'smtp-profiles', mode: 'edit' },
      },
      {
        name: 'generate',
        path: 'generate',
        component: () => import('../pages/control/GenerateReportPage.vue'),
      },
      {
        name: 'runs',
        path: 'runs',
        component: () => import('../pages/control/resources/ResourceListPage.vue'),
        props: { moduleKey: 'runs' },
      },
      {
        name: 'run-view',
        path: 'runs/:id',
        component: () => import('../pages/control/resources/RunViewPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/control/SettingsPage.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const session = authService.getSession()

  if (to.meta.requiresAuth && !session) {
    return { name: 'login' }
  }

  if (to.name === 'login' && session) {
    return { name: 'dashboard' }
  }

  return true
})

export default router
